import React, { useState, useRef, useEffect, Fragment } from 'react';
import propTypes from 'prop-types';
import _get from 'lodash/get.js';
import classNames from 'classnames';
import { fitToScreen } from '_ui-core-js/utilities/fitToScreen.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { fireGTMTrackingEvent } from '_ui-core-js/utilities/fireGTMTrackingEvent.js';
import { LandingScreen } from './LandingScreen.jsx';
import { ChoicesScreen } from './ChoicesScreen.jsx';
import { LoadingScreen } from './LoadingScreen.jsx';
import { RecommendationsScreen } from './RecommendationsScreen.jsx';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';
import { constants } from '../../constants/index.js';

const { INJECTION_ELEMENTS } = constants;

export const VIEWS = {
  landing: {
    name: 'landing',
    dataKey: 'welcome',
    fitToScreen: true,
    showMuteButton: true
  },
  choices: {
    name: 'choices',
    dataKey: 'quiz',
    fitToScreen: true,
    showMuteButton: false
  },
  loading: {
    name: 'loading',
    dataKey: 'results',
    fitToScreen: true,
    showMuteButton: false
  },
  recommendations: {
    name: 'recommendations',
    dataKey: 'recommendations',
    fitToScreen: false,
    showMuteButton: false
  },
};

const COMPONENTS = {
  landing: LandingScreen,
  choices: ChoicesScreen,
  loading: LoadingScreen,
  recommendations:  RecommendationsScreen
};

export function StyleSelector(props) {
  const block = 'c-style-selector';
  const data = useRef(_get(props, 'labels.style-selector', {}));
  const user = _get(props, 'user', {});
  const onClickActions = _get(props, 'onClickActions', {})
  const rootElRef = useRef();
  const fitToScreenRef = useRef();
  const [activeView, setActiveView] = useState(VIEWS.landing.name);
  const [audioMuted, setAudioMuted] = useState(true);
  const [recommendedAtmosphere, setRecommendedAtmosphere] = useState('elegant');
  const [yourNature, setYourNature] = useState();
  const [carColor, setCarColor] = useState('1L1');
  const [keywords, setKeywords] = useState();
  const disclaimerText = data.current.welcome?.disclaimer;

  const state = {
    activeView,
    setActiveView,
    audioMuted,
    recommendedAtmosphere,
    setRecommendedAtmosphere,
    yourNature,
    setYourNature,
    carColor,
    setCarColor,
    keywords,
    setKeywords
  };

  useEffect(() => {
    fitToScreenRef.current = fitToScreen(rootElRef.current, [document.querySelector(INJECTION_ELEMENTS.HEADER_SELECTOR)]);
  }, []);

  useEffect(() => {
    if (VIEWS[activeView].fitToScreen) {
      fitToScreenRef.current.init();
    } 
    else {
      fitToScreenRef.current.destroy();
    }
  }, [activeView]);

  useEffect(() => {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxStyleSelector, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.homeScreen,
      label: CORE_GTM_TRACKING_VALUES.label.view
    });
  }, []);

  const Component = COMPONENTS[activeView];

  return (
    <div className={block} ref={rootElRef}>
      <div className={`${block}__mute-button-container dark-theme theme-content-only`}>
        {
          VIEWS[activeView].showMuteButton &&
            <Fragment>
              <button className={
                classNames({
                  [`c-background-media__mute-button`]: true,
                  [`c-background-media__mute-button--active`]: audioMuted
                })}
              onClick={() => setAudioMuted(prevValue => !prevValue)}>
              </button>
              { 
                (VIEWS[activeView].name === VIEWS.landing.name && disclaimerText) && 
                  <span className='caveat'>{ disclaimerText }</span> 
              } 
            </Fragment>
        }
      </div>
      <Component 
      block={block} 
      rootElRef={rootElRef} 
      state={state} 
      data={data.current[VIEWS[activeView].dataKey]}
      user={user}
      onClickActions={onClickActions} 
      />   
    </div>
  )
};

StyleSelector.propTypes = {
  labels: propTypes.object
};